import $ from 'jquery'

$(function(){
	$("li[role='tab']").click(function(){  
		$("li[role='tab']").attr("aria-selected","false").removeClass('active'); //deselect all the tabs 
		$(this).attr("aria-selected","true").addClass('active');  // select this tab
		var tabpanid= $(this).attr("aria-controls"); //find out what tab panel this tab controls  
		var tabpan = $("#"+tabpanid);  
		$("div[role='tabpanel']").attr("aria-hidden","true"); //hide all the panels 
		tabpan.attr("aria-hidden","false");  // show our panel  
		if ($('.quiz').length > 0 ) {
			$('.result-panel').hide();
			$('.results').hide();
			$('.question').show();
			$('.answers').show();
			$('.quiz .submit button').show();
		}
	});
	$("li[role='tab']").keydown(function(ev) { 
		if ((ev.which ==39)||(ev.which ==37)) { 
			var selected= $(this).attr("aria-selected"); 
			if (selected =="true"){ 
				$("li[aria-selected='false']").attr("aria-selected","true").focus() ; 
				$(this).attr("aria-selected","false"); 
				var tabpanid= $("li[aria-selected='true']").attr("aria-controls"); 
				var tabpan = $("#"+tabpanid); 
				$("div[role='tabpanel']").attr("aria-hidden","true"); 
				tabpan.attr("aria-hidden","false");
			}
		}
	});
	$("li[role='tab']").keydown(function(ev) {
		if (ev.which ==13) {
			$(this).click()
		}
	});
});